export type ReactionRow={id:string;messageId:string;userId:string;emoji:string};
export type ReactionEdit={messageId:string;userId:string;emoji:string;desired:boolean;confirmed:ReactionRow|null;running:boolean;acknowledged:boolean;temporaryId:string};
export const reactionKey=(messageId:string,userId:string,emoji:string)=>JSON.stringify([messageId,userId,emoji]);
export function applyReactionEdits(rows:ReactionRow[],edits:Map<string,ReactionEdit>,authoritative=false){
  let result=[...rows];
  for(const [key,edit] of edits){
    const matches=(row:ReactionRow)=>row.messageId===edit.messageId&&row.userId===edit.userId&&row.emoji===edit.emoji;
    const saved=rows.find(matches);
    if(authoritative&&edit.acknowledged&&!!saved===edit.desired){edits.delete(key);continue;}
    result=result.filter(row=>!matches(row));
    if(edit.desired)result.push(edit.confirmed||{id:edit.temporaryId,messageId:edit.messageId,userId:edit.userId,emoji:edit.emoji});
  }
  return result;
}
